
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private snackBar: MatSnackBar, private languageService: LanguageService) { }

  /**
   * Messaggio errore API 
   */
  showApiError(messageKey: string = 'notification.apiError'): void {
    const message = this.languageService.translate(messageKey);
    this.snackBar.open(message, this.languageService.translate('notification.close'), {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['error-snackbar']
    });
  }

  /**
   * Messaggio di successo
   */
  showSuccess(messageKey: string): void {
    const message = this.languageService.translate(messageKey);
    this.snackBar.open(message, this.languageService.translate('notification.close'), {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['success-snackbar']
    });
  }

  /**
   * Messaggio di avviso
   */
  showWarning(messageKey: string): void {
    const message = this.languageService.translate(messageKey);
    this.snackBar.open(message, this.languageService.translate('notification.close'), {
      duration: 4000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['warning-snackbar']
    });
  }
}